import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import exam from '../views/Exam.vue'
import test from '../views/test.vue'
import startexam from '../views/StartExam.vue'
import reviewexam from '../views/ReviewExam.vue'

// var Cookies = require('vue-cookies')
// var userPermissions = Cookies.get('userPermissions')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      name: 'dashboard'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { layout: 'loginlayout' }
  },
  {
    path: '/applogin/:studentId/:appos',
    name: 'applogin',
    meta: { layout: 'loginlayout' }
  },
  {
    path: '/force_reset',
    name: 'force_reset',
    component: () => import('../views/ForceReset.vue'),
    meta: { layout: 'loginlayout' }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/Course.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/subjects',
    name: 'subjects',
    component: () => import('../views/Subjects.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/chapters',
    name: 'chapters',
    component: () => import('../views/Chapters.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/topics',
    name: 'topics',
    component: () => import('../views/Topics.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/topic_quiz',
    name: 'topic_quiz',
    component: () => import('../views/Quiz.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/my_payments',
    name: 'mypayments',
    component: () => import('../views/MyPayments.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../views/Calendar.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/chat_with_teacher',
    name: 'chatwithteacher',
    component: () => import('../views/ChatwithTeacher.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/browse_course',
    name: 'browsecourse',
    component: () => import('../views/BrowseCourse.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/classroom',
    name: 'classroom',
    component: () => import('../views/ClassRoom.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/EditProfile.vue'),
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/exam',
    name: 'exam',
    component: exam,
    meta: { layout: 'defaultlayout' }
  },
  {
    path: '/start_exam',
    name: 'startexam',
    component: startexam,
    meta: { layout: 'examlayout' }
  },
  {
    path: '/review_exam',
    name: 'reviewexam',
    component: reviewexam,
    meta: { layout: 'defaultlayout' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
